
import React, { Component } from 'react';
import styles from './ProgressFeel.module.sass';
import PathContext from "../../context/path";
import Circles from '../Circles/Circles';
class ProgressFeel extends Component {


	state = {
		opened: false,
		stages: 14,

		step: 7.14
	};
	stage = 0;
	refTitle = React.createRef();
	refDate = React.createRef();
	refText = React.createRef();

	data = [
		{
			"stage": 0,
			"title": "",
			"date": "",
			"img": "",
			"text": [""]
		},
		{
			"stage": 1,
			"title": "Acute HIV infection",
			"date": "from two weeks to six months",
			"img": "/img/gifs/walk/walk1.gif",
			"text": ["Following infection you may experience light symptoms similar to those of a cold. It’s more likely, however, that you won’t notice any difference."]
		},
		{
			"stage": 2,
			"title": "Symptom-free stage",
			"date": "1 year",
			"img": "/img/gifs/walk/walk1.gif",
			"text": ["This is the virus’s longest phase. The virus builds up, reproducing itself and destroying cells in the body’s immunity system. You don’t notice any changes."]
		},
		{
			"stage": 3,
			"title": "Symptom-free stage",
			"date": "2 years",
			"img": "/img/gifs/walk/walk1.gif",
			"text": ["This is the virus’s longest phase. The virus builds up, reproducing itself and destroying cells in the body’s immunity system. You don’t notice any changes."]
		},
		{
			"stage": 4,
			"title": "Symptom-free stage",
			"date": "3 years",
			"img": "/img/gifs/walk/walk1.gif",
			"text": ["This is the virus’s longest phase. The virus builds up, reproducing itself and destroying cells in the body’s immunity system. You don’t notice any changes."]
		},
		{
			"stage": 5,
			"title": "Symptom-free stage",
			"date": "4 years",
			"img": "/img/gifs/walk/walk1.gif",
			"text": ["This is the virus’s longest phase. The virus builds up, reproducing itself and destroying cells in the body’s immunity system. You don’t notice any changes."]
		},
		{
			"stage": 6,
			"title": "Symptom-free stage",
			"date": "5 years",
			"img": "/img/gifs/walk/walk2.gif",
			"text": ["During this time, you could go on a round-the-world voyage, grow a small tree, change profession.","And suspect nothing."]
		},
		{
			"stage": 7,
			"title": "Symptom-free stage",
			"date": "6 years",
			"img": "/img/gifs/walk/walk3.gif",
			"text": ["For some people, this stage can last 20 years and over."]
		},
		{
			"stage": 8,
			"title": "Symptom-free stage",
			"date": "7 years",
			"img": "/img/gifs/walk/walk3.gif",
			"text": ["For some people, this stage can last 20 years and over."]
		},
		{
			"stage": 9,
			"title": "Symptom-free stage",
			"date": "8 years",
			"img": "/img/gifs/walk/walk3.gif",
			"text": ["For some people, this stage can last 20 years and over."]
		},
		{
			"stage": 10,
			"title": "Terminal stage – AIDS",
			"date": "9 years",
			"img": "/img/gifs/walk/walk4.gif",
			"text": ["It’s only after 8 to 10 years that the virus makes itself apparent. The immune cells reach a critical minimum.", "HIV moves to the Acquired Immune Deficiency Syndrome (AIDS) stage."]
		},
		{
			"stage": 11,
			"title": "Terminal stage – AIDS",
			"date": "10–12 years",
			"img": "/img/gifs/walk/walk4_5.gif",
			"text": ["Over a period of about three years in the AIDS stage, the immunity system completely stops carrying out its protective functions."]
		},
		{
			"stage": 12,
			"title": "Terminal stage – AIDS",
			"date": "10–12 years",
			"img": "/img/gifs/walk/walk5.gif",
			"text": ["The organism collapses. "]
		},
		{
			"stage": 13,
			"title": "Terminal stage – AIDS",
			"date": "10–12 years",
			"img": "/img/gifs/walk/walk5.gif",
			"text": ["The organism collapses. "]
		}
	];
	title = '';
	date = '';
	text = [];
	img = '/img/gifs/walk/walk1.gif';
	stageBody = null;
	static contextType = PathContext;
	path = this.context;
	componentDidMount() {
		this.stage = Math.round(this.props.progress / this.state.step);
		this.setStage = this.setStage.bind(this);
		this.setStage();
		this.data.forEach((item) => {
			const img = new Image();
			img.src = `${this.path}${item.img}`;
		});
		window.addEventListener('scroll', this.setStage);
		this.setState({});

	}
	componentWillUnmount() {
		window.removeEventListener('scroll', this.setStage.bind(this), false);
	}

	checkData(stage) {
		if (this.data[this.stage].title !== this.data[stage].title) {
			// this.refTitle.current.style.opacity = 0;
			this.title = this.data[stage].title;
			this.setState({});
		}
		if (this.data[this.stage].date !== this.data[stage].date) {
			this.date = this.data[stage].date;
			this.setState({});
		}
		if (this.data[this.stage].text !== this.data[stage].text) {
			this.text = [];
			if (this.data[stage].stage === 6) {
				this.data[stage].text.forEach((item, index)=>{
					this.text[index] = <p key={index}><span>{item}</span></p>;
				});
				
			} else {
				this.data[stage].text.forEach((item, index)=>{
					this.text[index] = <p key={index}>{item}</p>;
				});
			}
			this.setState({});
		}
		if (this.data[this.stage].img !== this.data[stage].img) {
			this.img = this.data[stage].img;
			this.setState({});
		}
	}
	setStage() {
		let stage = Math.round(this.props.progress / this.state.step);

		if (stage <= (this.state.stages - 1)) {

			this.checkData(stage);
			this.stage = stage;
		}

		if (stage === 0) {
			this.stageBody = <div className={styles.stage}>
				<div className={styles.stat}>
					<div className={`${styles.stat_path} ${styles.stat_path_left}`}>
						<div className={styles.stat_bar}></div>
						<div className={styles.stat_number}>6–8 years</div>
						<div className={styles.stat_text}>HIV develops without symptoms</div>
					</div>
					<div className={`${styles.stat_path} ${styles.stat_path_right}`}>
						<div className={styles.stat_bar}></div>
						<div className={styles.stat_number}>2-3 years</div>
						<div className={styles.stat_text}>first noticeable symptoms</div>
					</div>
				</div>
				<div className={styles.text_blue}  data-aos="fade-up">If you are infected, for a major period of time it is likely that you will not notice the virus’s presence</div>
				<div className={styles.scroll}>
					<span>Scroll down to launch the timeline.</span>
					<img src={`${this.path}/img/scroll-arrow.svg`} alt="" />
				</div>

			</div>;
		} else {
			let legend = null;
			let scroll = <img src={`${this.path}/img/scroll-arrow.svg`} alt="" />;
			if (stage === 1) {
				legend = <div className={styles.legend}>
					<span>HIV cells </span>
					<span>CD4 cells</span>
				</div>
			}
			if (stage === 14) {
				scroll = null;
			} else {
				scroll = <img src={`${this.path}/img/scroll-arrow.svg`} alt="" />;
			}
			this.stageBody = <div className={`${styles.stage}`}>
				<div ref={this.refTitle} className={styles.stage_title}>{this.title}</div>
				<div className={styles.bar}>
					<div style={{ width: `${this.props.progress}%` }}>
						<span></span>
						<span></span>
					</div>
				</div>
				<div ref={this.refDate} className={styles.date}>{this.date}</div>
				<div className={styles.body}>
					{legend}
					<div className={styles.img}>
						<img src={`${this.path}${this.img}`} alt="" />
					</div>
					<div className={styles.circles}>
						<Circles perRow={12} allCircles={96} />
					</div>
				</div>
				<div ref={this.refText} className={styles.stage_text}>{this.text}</div>
				<div className={styles.scroll}>

					{scroll}
				</div>
			</div>;
			let circles = document.querySelectorAll('.circle');
			let step = 96 / 99;
			let numbers = Math.round(this.props.progress * step)
			let activeColor = '#2F80ED';

			if (this.props.progress < 66) {
				activeColor = '#2F80ED';
			} else {
				activeColor = '#FD4B2C';
			}
			circles.forEach((circle, number) => {
				if (number < numbers) {
					circle.style.setProperty('--color', `${activeColor}`);
				} else {
					circle.style.setProperty('--color', '#E0E0E0');
				}
			});
		}
	}
	render() {
		let titleClass = `${styles.title}`;
		let textClass = `${styles.text}`;
		let stageClass = `${styles.stage_body}`;
		if (this.props.progress > 3 && window.innerWidth > 767) {
			// titleClass = `${styles.title} ${styles.title_hide}`;
			textClass = `${styles.text} ${styles.text_hide}`;
			stageClass = `${styles.stage_body} ${styles.stage_body_active}`;
		} else {
			// titleClass = `${styles.title}`;
			textClass = `${styles.text}`;
			stageClass = `${styles.stage_body}`;
		}
		return (
			<div className={styles.inner}>
				<div className={styles.bg1}>
					<picture>
						<source media="(min-width: 768px)" srcSet={`${this.path}/img/feel-progress-desktop.png`} />
						<img src={`${this.path}/img/feel-progress-bg.png`} alt="" />
					</picture>
				</div>

				<div className="container" data-aos="fade-up">
					<h2 className={titleClass} >
					HIV progresses slowly and imperceptibly
					</h2>
					<div className={textClass}>
					One of the dangers of HIV infection is that it can have no symptoms for many years. During that time, a person can be actively transmitting the virus without even suspecting that he or she is infected.
					</div>
					<div className={stageClass}>
						{this.stageBody}
					</div>
				</div>

			</div>
		);
	}
}

export default ProgressFeel;
